import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  lessonData: [],
  lessonCount: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
}

export const lessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    setlessonData(state, { payload }) {
      state.lessonData = payload.result;
      state.lessonCount = payload.total
    },
    updatelessonData(state, { payload }) {
      const objIndex = state.lessonData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.lessonData[objIndex] = payload
      }
    },
    deletelessonData(state, { payload }) {
      const objIndex = state.lessonData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.lessonData.splice(objIndex, 1)
      }
    },
    pushlessonData(state, { payload }) {
      state.lessonData.push(payload)
      state.lessonCount +=1;
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    }
  }
})

export const { setlessonData, updatelessonData, deletelessonData, pushlessonData, isOpenModal,
  ModalToggle, setFaqsSpecializationData, isOpenStatusModal, statusToggle } = lessonSlice.actions;

export default lessonSlice.reducer;

export function getLesson(limit, offset, status, keyword, id) {
  return async function getlessonThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getlesson(limit, offset, status, keyword, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setlessonData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addlesson(payload) {
  return async function addlessonThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addlesson(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushlessonData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatelesson(id, data) {
  return async function updatelessonThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatelesson(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updatelessonData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdatelesson(payload) {
  return async function statusUpdatelessonThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatelesson(payload.id, payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updatelessonData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function statusDeletelesson(payload) {
  return async function statuseletelessonThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatelesson(payload.id, payload.status).then(
        (response) => {
          dispatch(deletelessonData(payload.id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

